import { DraggableWorkflowBuilderItem, WorkflowBuilderItem } from 'components/WorkflowBuilderItem/WorkflowBuilderItem'
import { DragDropContext, Droppable, OnDragEndResponder } from 'react-beautiful-dnd'
import { Workflow } from 'stores/Workflows/Workflow'
import Styles from './List.module.scss'
import { observer } from 'mobx-react-lite'

interface Props {
  workflow: Workflow
}

export const List = observer(({ workflow }: Props) => {
  const [[defaultState], ...draggableGroups] = workflow.groupedStates

  const handleDragEnd: OnDragEndResponder = (result) => {
    const fromPos = result.source.index
    const toPos = result.destination?.index
    if (!toPos) {
      return
    }

    const mainStatesKeys = workflow.states.filter((state) => !state.isChild).map((state) => state.key)
    mainStatesKeys.splice(toPos, 0, mainStatesKeys.splice(fromPos, 1)[0])

    let pos = 0
    mainStatesKeys.forEach((key) => {
      const state = workflow.getState(key)
      state.setPosition(pos)
      pos++
      state.childStates.forEach((childState) => {
        childState.setPosition(pos)
        pos++
      })
    })
  }

  return (
    <>
      <div className={Styles.headers}>
        <div>File Status</div>
        <div>Automation</div>
      </div>
      <WorkflowBuilderItem key={defaultState.key} states={[defaultState]} />

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable">
          {(provider) => (
            <div {...provider.droppableProps} ref={provider.innerRef}>
              {draggableGroups.map((group, index) => (
                <DraggableWorkflowBuilderItem key={group[0].key} states={group} index={index + 1} />
              ))}
              {provider.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  )
})
